import { render, staticRenderFns } from "./TopPanel.vue?vue&type=template&id=10b57fb7&scoped=true&"
import script from "./TopPanel.vue?vue&type=script&lang=js&"
export * from "./TopPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b57fb7",
  null
  
)

export default component.exports